// ─────────────────────────────────────────────────────────────────────────────
// Single source of truth for RR Industries' own company details used across
// every Proforma Invoice / Quotation PDF (QuotationApp.jsx, PICreator.jsx,
// PIView.jsx) and the on-screen totals preview.
//
// Change a value here and it updates everywhere the PDF is generated —
// no need to hunt through each component.
// ─────────────────────────────────────────────────────────────────────────────

const COMPANY_INFO = {
  name: "RR INDUSTRIES",
  tagline: "STRENGTH  •  QUALITY  •  TRUST",
  gstin: "23FIVPR9101R1Z8",
  hsnCode: "72255010",

  // Full registered address, split the way it wraps in the PDF header.
  addressLine1: "Word No. 9, Lalburra Rode,",
  addressLine2: "Garra Industrial Area, Garra, Balaghat, Madhya Pradesh, 481001",
  // Shorter one-line form used in the PDF footer strip.
  addressShort: "Garra Industrial Area, Garra, Balaghat, MP",

  phone: "+91 7987779610",
  email: "rrwindowsolution@gmail.com",

  // Served from the /public folder — referenced directly by jsPDF's addImage().
  logo: "/logo.png",
  sealSign: "/seal-sign.png",

  // Default names shown on the signature block until overridden per-PI.
  preparedByDefault: "SHIVAM",
  authorizedByDefault: "SABHYA RAHANGDALE",
  signatoryLine1: "R.R. INDUSTRIES",
  signatoryLine2: "GARRA, BALAGHAT",

  bank: {
    name: "STATE BANK OF INDIA (SBI)",
    accountNo: "45492341999",
    ifsc: "SBIN0030394",
    branch: "SUBHASH CHOWK BALAGHAT",
    address: "MADHYA PRADESH",
  },

  // Fraction (0.18 = 18%) — used both for the PDF's IGST line and the
  // on-screen totals preview.
  gstRate: 0.18,
  footerNote: "Note: GST @ 18% is applicable on freight charges.",
};

export default COMPANY_INFO;
